import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CoreValue {
  id: number;
  icon: string;
  title: string;
  description: string;
  color: string;
}

interface CoreValuesProps {
  values: CoreValue[];
}

const CoreValues: React.FC<CoreValuesProps> = ({ values }) => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-success/10 px-4 py-2 rounded-full mb-4">
            <Icon name="HeartIcon" size={20} className="text-success" variant="solid" />
            <span className="text-sm font-cta font-semibold text-success">Our Core Values</span>
          </div>
          
          <h2 className="font-headline font-bold text-3xl lg:text-4xl text-primary mb-4">
            The Principles That Guide Everything We Do
          </h2>
          
          <p className="font-body text-lg text-muted-foreground leading-relaxed">
            Our values aren't just words on a wall—they're the foundation of every decision, every interaction, and every solution we deliver.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {values.map((value) => (
            <div
              key={value.id}
              className="bg-card rounded-xl shadow-card hover:shadow-elevated transition-all duration-300 p-8 border border-border group hover:border-accent"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${value.color} rounded-xl flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={value.icon as any} size={32} className="text-white" variant="solid" />
              </div>
              
              <h3 className="font-headline font-bold text-xl text-primary mb-3">
                {value.title}
              </h3>
              
              <p className="font-body text-muted-foreground leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;